import {createNewsletterRecovery} from './newsletter_recovery.js?v=molten-newsletter-recovery-20261011-r3';
import {recoverProductParams} from './native_form_adapter.js?v=molten-explicit-names-20261012-r1';
import {createDirectForm} from './molten-enquiry-explicit-names-r1.js?v=molten-accepted-analytics-20261019-r1';
import {loadVendor,createWidgetVerifier} from './turnstile_browser.js?v=molten-verification-diagnostics-20261020-r1';
(() => {
  'use strict';
  const page = document.querySelector('.enquiry-page');
  if (!page || page.dataset.initialised) return;
  page.dataset.initialised = 'true';
  const form = page.querySelector('#MoltenEnquiry');
  const newsletter = page.querySelector('#MoltenEnquiryNewsletter');
  const firstName=form.elements['contact[first_name]'],lastName=form.elements['contact[last_name]'],fullName=form.elements['contact[name]'];
  let legacyNameMode=false;
  const syncNames=()=>{
    if(legacyNameMode||(firstName.disabled&&lastName.disabled))return;
    fullName.value=(firstName.value.trim()+' '+lastName.value.trim()).trim();
    firstName.maxLength=Math.min(100,Math.max(1,199-lastName.value.trim().length));
    lastName.maxLength=Math.min(100,Math.max(1,199-firstName.value.trim().length));
  };
  const showLegacyName=()=>{
    legacyNameMode=true;page.querySelector('.enquiry-names').hidden=true;
    firstName.required=false;lastName.required=false;firstName.disabled=true;lastName.disabled=true;
    page.querySelector('[data-legacy-name]').hidden=false;fullName.type='text';fullName.readOnly=true;
  };
  firstName.addEventListener('input',syncNames);lastName.addEventListener('input',syncNames);


  const params = new URLSearchParams(location.search);
  const toggle = page.querySelector('.general-toggle');
  if (toggle) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    page.querySelector('#general-contact-panel').hidden = !open;
    const media = page.querySelector('.general-media');
    if (media && !page.classList.contains('enquiry-family-accepted')) media.hidden = open;
  });
  const sourceField = document.createElement('input'); sourceField.type = 'hidden'; sourceField.name = 'contact[Source page]';
  try { const source = new URL(document.referrer); if (source.origin === location.origin) sourceField.value = source.pathname; } catch {}
  if (!sourceField.value) sourceField.value = location.pathname;
  page.querySelector('[data-design-fields]').append(sourceField);

  const general = page.classList.contains('general-enquiry');
  const key = general ? 'molten-general-enquiry-pending-v1' : 'molten-bespoke-enquiry-pending-v1';
  const expiry = 20 * 60 * 1000;
  const root = window.Shopify?.routes?.root || '/';
  const fields = ['contact[first_name]', 'contact[last_name]', 'contact[name]', 'contact[email]', 'contact[body]', 'contact[phone]', 'contact[Preferred initial contact method]'];
  let ready = false;
  const readPending = () => {
    try {
      const pending = JSON.parse(sessionStorage.getItem(key));
      if (!pending || Date.now() - pending.time > expiry || pending.path !== location.pathname) {
        sessionStorage.removeItem(key); return null;
      }
      return pending;
    } catch { return null; }
  };
  const save = value => { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } };
  const remove = () => { try { sessionStorage.removeItem(key); } catch {} };
  const method = () => {
    const selected = form.querySelector('input[type=radio]:checked')?.value;
    page.querySelector('#phone').required = Boolean(selected && selected !== 'Email');
    page.querySelector('#phone-optional').hidden = Boolean(selected && selected !== 'Email');
  };
  form.querySelectorAll('input[type=radio]').forEach(input => input.addEventListener('change', method));
  const newsletterRecovery = createNewsletterRecovery({storage:sessionStorage,family:page.dataset.receiverFamily,path:location.pathname});
  const pending = readPending();
  const correlated = pending && params.get('enquiry_attempt') === pending.token;
  const contactAccepted = page.querySelector('[data-contact-accepted]').textContent.trim() === 'true';
  const newsletterAccepted = page.querySelector('[data-newsletter-accepted]').textContent.trim() === 'true';
  const contactErrors = page.querySelector('[data-contact-errors]').textContent.trim();
  const newsletterErrors = page.querySelector('[data-newsletter-errors]').textContent.trim();
  function returnPath(token, phase) {
    const query = new URLSearchParams();
    for (const field of ['view', 'preview_theme_id', 'design_handle', 'intent']) {
      if (params.getAll(field).length === 1) query.set(field, params.get(field));
    }
    query.set('enquiry_attempt', token); query.set('enquiry_phase', phase);
    // Custom native success redirects do not append Shopify's result flags.
    // Restore the appropriate flag only in the posted success return path;
    // the tab-specific pending token and consent remain required on return.
    query.set(phase === 'contact' ? 'contact_posted' : 'customer_posted', 'true');
    return `${location.pathname}?${query}`;
  }
  function setReturn(target, path) {
    let input = target.querySelector('input[name=return_to]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; target.append(input); }
    input.value = path;
  }
  function showReceipt() {
    form.hidden=true;page.classList.add('enquiry-family-accepted');
    const receipt=page.querySelector('[data-enquiry-receipt]');
    const related=receipt.querySelector('[data-confirmation-related]');
    for(const node of [toggle,page.querySelector('#general-contact-panel')])if(node&&node.parentElement!==related)related.append(node);
    const welcome=page.querySelector('.enquiry-welcome');for(const node of [...welcome.children])if(node.matches('h1,.enquiry-intro'))node.hidden=true;
    const firstReveal=receipt.hidden;receipt.hidden=false;if(firstReveal)receipt.focus();
  }

  function startNewsletter(state, automatic = false) {
    page.querySelector('[data-newsletter-panel]').hidden = false;
    newsletter.elements['contact[email]'].value = state.email;
    setReturn(newsletter, returnPath(state.token, 'newsletter'));
    newsletter.querySelector('button').disabled = false;
    if (!automatic) return;
    const protect = () => {
      if (window.Shopify?.captcha?.protect) {
        window.Shopify.captcha.protect(newsletter, () => newsletter.submit());
      }
    };
    if (document.readyState === 'complete') protect();
    else window.addEventListener('load', protect, { once: true });
  }
  const acceptedRecovery = newsletterRecovery.read();
  const fallbackReceipt = !acceptedRecovery && newsletterRecovery.readFallback();
  let newsletterRecovered = Boolean(acceptedRecovery || fallbackReceipt);
  const receiptWithContext = () => {
    if (page.dataset.receiverFamily === 'gold-swap') reveal(true);
    showReceipt();
  };
  if (acceptedRecovery) {
    newsletterRecovery.finish({
      token: params.getAll('enquiry_attempt').length === 1 ? params.get('enquiry_attempt') : null,
      phase: params.getAll('enquiry_phase').length === 1 ? params.get('enquiry_phase') : null,
      accepted: newsletterAccepted,
      errors: newsletterErrors
    });
    remove();
    try { sessionStorage.removeItem('molten-direct-enquiry-' + page.dataset.receiverFamily + '-v1'); } catch {}
    receiptWithContext();
    const remaining = newsletterRecovery.read();
    if (remaining?.status === 'pending') startNewsletter(remaining);
  } else if (fallbackReceipt) {
    remove(); receiptWithContext();
  } else if (correlated && params.get('enquiry_phase') === 'contact' && contactAccepted && !contactErrors) {
    // Native Shopify acceptance is a separate proof kind, never a receiver id.
    receiptWithContext();
    let acceptedNative;
    try {
      acceptedNative = newsletterRecovery.remember({
        proof: {kind:'native-contact',id:null}, token:pending.token,
        email:pending.email || '', consent:pending.consent === true, time:pending.time
      });
    } catch {}
    remove();
    newsletterRecovered = true;
    if (acceptedNative?.status === 'pending') startNewsletter(acceptedNative, true);
    else if (pending.consent && pending.email) {
      page.querySelector('[data-newsletter-panel]').hidden = false;
      newsletter.elements['contact[email]'].value = pending.email;
      newsletter.querySelector('button').disabled = false;
    }
  } else if (correlated && pending.fields && contactErrors) {
    for (const [name, value] of Object.entries(pending.fields)) {
      const inputs = [...form.querySelectorAll('input,textarea')].filter(el => el.name === name);
      for (const input of inputs) {
        if (input.type === 'radio') input.checked = input.value === value;
        else input.value = value;
      }
    }
    page.querySelector('#email-updates').checked = Boolean(pending.consent);
    method();
  }
  async function resolveDesign() {
    if (general) { ready = true; form.querySelector('[type=submit]').disabled = false; return; }
    const contextKeys = ['design_handle', 'design_title', 'product_url', 'intent'];
    if (!contextKeys.some(field => params.has(field))) {
      ready = true; form.querySelector('[type=submit]').disabled = false; return;
    }
    if (contextKeys.some(field => params.getAll(field).length > 1)) throw new Error('Invalid context');
    const handle = params.get('design_handle') || '';
    if (handle.length > 200 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle) || params.get('intent') !== 'bespoke-design') throw new Error('Missing context');
    const url = new URL(`${root}products/${handle}`, location.origin);
    url.searchParams.set('view', 'molten-enquiry-context');
    const preview = params.get('preview_theme_id');
    if (/^\d+$/.test(preview || '')) url.searchParams.set('preview_theme_id', preview);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    let product;
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Product unavailable');
      product = await response.json();
    } finally { clearTimeout(timer); }
    const title = product.displayTitle;
    if (product.handle !== handle || typeof title !== 'string' || !title.trim() || title.length > 500 || /[\u0000-\u001f\u007f]/.test(title)) throw new Error('Invalid product');
    const reference = page.querySelector('[data-design-reference]');
    reference.querySelector('.enquiry-design-title').textContent = title;
    const back = reference.querySelector('a');
    back.href = `${root}products/${handle}`; back.hidden = false;
    const backQuery = new URLSearchParams();
    if (/^\d+$/.test(preview || '')) backQuery.set('preview_theme_id', preview);
    // Only the known same-origin product review views may survive the return.
    // Caller-supplied product_url never becomes a navigation destination.
    try {
      const source = new URL(document.referrer);
      const sourceView = source.searchParams.get('view');
      if (source.origin === location.origin && source.pathname === `${root}products/${handle}` &&
          ['bespoke-pdp-r3-review', 'bespoke-pdp-saved-qa'].includes(sourceView)) {
        backQuery.set('view', sourceView);
      }
    } catch {}
    back.search = backQuery.toString();
    const image = reference.querySelector('img');
    if (typeof product.image === 'string') {
      const source = new URL(product.image, location.origin);
      if (source.protocol === 'https:' && (source.hostname === location.hostname || source.hostname === 'cdn.shopify.com' || source.hostname === 'www.moltenstore.com')) {
        image.addEventListener('load', () => { image.hidden = false; }, { once: true });
        image.addEventListener('error', () => { image.hidden = true; }, { once: true });
        image.alt = title; image.src = source.href;
      }
    }
    reference.hidden = false;
    const context = {
      'contact[Design]': title,
      'contact[Design handle]': handle,
      'contact[Design URL]': `https://www.moltenstore.com/products/${handle}`,
      'contact[Enquiry intent]': 'bespoke-design'
    };
    for (const [name, value] of Object.entries(context)) {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value;
      page.querySelector('[data-design-fields]').append(input);
    }
    ready = true; form.querySelector('[type=submit]').disabled = false;
  }
  const family=page.dataset.receiverFamily;
  let clientVerifier;
  const direct=createDirectForm({page,family,fetchImpl:window.fetch.bind(window),storage:window.sessionStorage,path:location.pathname,
    verify:async()=>{
      if(!clientVerifier){const vendor=await loadVendor(document,window);clientVerifier=createWidgetVerifier({vendor,container:page.querySelector('[data-enquiry-verification]'),family,siteKey:'0x4AAAAAAFSNLvKvsAMqGacF',compact:form.getBoundingClientRect().width<300});}
      return clientVerifier();
    },
    onAcceptedReceipt:({submissionId,email,newsletterChecked})=>{
      newsletterRecovery.remember({proof:{kind:'receiver',id:submissionId},token:crypto.randomUUID(),email,consent:newsletterChecked});
      remove(); newsletterRecovered=true;
    },
    onAccepted:(result)=>{
      newsletterRecovered=true; receiptWithContext();
      if(result.newsletter==='retry-separately' && result.newsletterEmail){
        page.querySelector('[data-newsletter-panel]').hidden=false;
        newsletter.elements['contact[email]'].value=result.newsletterEmail;
        newsletter.querySelector('button').disabled=false;
      }
    },
    subscribeNewsletter:async({email,family,submissionId})=>{
      const state=newsletterRecovery.read();
      if(!state||state.proof.kind!=='receiver'||state.proof.id!==submissionId)throw Error('Accepted newsletter proof unavailable');
      receiptWithContext();
      if(state.status==='pending')startNewsletter(state,true);
    }
  });
  // Recover and resolve the original held product before enabling retry.
  recoverProductParams(params,family,direct.pendingProductHandle());
  form.addEventListener('submit', event => {
    if (newsletterRecovered) { event.preventDefault(); return; }
    event.preventDefault();
    if(!ready)return;
    syncNames();
    if(!form.checkValidity()){form.reportValidity();return;}
    direct.submit(event);
  });
  resolveDesign().catch(() => { page.querySelector('[data-context-error]').hidden = false; });
})();

